import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { RankingConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CvRankService } from './api/cvRank.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class RankingApiModule {
    public static forRoot(configurationFactory: () => RankingConfiguration): ModuleWithProviders<RankingApiModule> {
        return {
            ngModule: RankingApiModule,
            providers: [ { provide: RankingConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: RankingApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('RankingApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
